import { z, ZodType } from 'zod';

export type Account = {
	id: number;
	name: string;
	note: string | null;
	isLocked: boolean;
	createdAt: string;
};

export const accountSchema: ZodType<Account> = z.object({
	id: z.number(),
	name: z.string(),
	note: z.string().nullable(),
	isLocked: z.boolean(),
	createdAt: z.string(),
});
